export const loadingIconClass = 'button-loading-icon';
